import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

const ReactiveDiv = styled.div`
    .reactive {
        margin-top: 100px;
        margin-left: ${(props) => props.marginLeft};
    }
`;

const About = (props) => {
    const { isSignedIn, themeColors, dashboardSidebarSize } = props;
    return (
        <ReactiveDiv
            themeColors={themeColors}
            marginLeft={isSignedIn ? dashboardSidebarSize : "0px"}
        >
            <div className="reactive">
                <h1>About</h1>
            </div>
        </ReactiveDiv>
    )
}

const mapStateToProps = (state) => {
    // console.log(state)
    return {
        isSignedIn: !state.firebase.auth.isEmpty,
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
    }
}

export default connect(mapStateToProps)(About);
